const emerald2Module = angular.module('emerald2', []);

const emProductTile2 = require('./em-product-tile-2/em-product-tile-2.component');

emerald2Module.component({
  emProductTile2
});

module.exports = emerald2Module;